module.exports = __webpack_public_path__ + "futura-light-webfont-a1fd0ddb3b5b7c77df1a3579867cf521.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/static/fonts/futura-light-webfont.ttf
 ** module id = 1533
 ** module chunks = 0
 **/